import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.nav`
  position: relative;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  background: ${props => props.theme.colors.navBackground};
  z-index: 105;
`;

export const PcBox = styled(DefaultBox)`
  padding: 0.5rem 2rem;
`;

export const MobileBox = styled(DefaultBox)`
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.brandSecondary};
`;

export const HeaderNavbarContainerDefaultBox = styledByDevice(PcBox, MobileBox);
